import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-resource-content',
  templateUrl: './resource-content.component.html',
  styleUrls: ['./resource-content.component.css']
})
export class ResourceContentComponent implements OnInit {
  @Input() content: any;

  ngOnInit(): void {
  }

}
